import { useState } from "react";
import {
  FaFacebookF,
  FaXTwitter,
  FaLinkedinIn,
  FaYoutube,
  FaInstagram,
  FaTiktok,
} from "react-icons/fa6";

export default function Footer({
  brand = "AllWell Companion Home Care",
  phoneDisplay = "(630) 339-9000",
  phoneHref = "tel:16303399000",
  officeFinderPlaceholder = "City, State or Zipcode",
  onNewsletterSubmit, // (email, zip) => void
  onFindLocation, // (query) => void
  onOpenFranchise, // () => void (optional: hide if undefined)
}) {
  // newsletter form state
  const [email, setEmail] = useState("");
  const [zip, setZip] = useState("");
  // location finder state
  const [loc, setLoc] = useState("");

  const submitNewsletter = (e) => {
    e.preventDefault();
    if (onNewsletterSubmit) onNewsletterSubmit(email, zip);
    setEmail("");
    setZip("");
  };

  const submitFinder = (e) => {
    e.preventDefault();
    if (onFindLocation) onFindLocation(loc);
  };

  return (
    <footer className="bg-[#253043] text-white pt-12">
      <div className="max-w-7xl mx-auto px-6">
        {/* Top band */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 pb-10 border-b border-white/15">
          {/* Left: Newsletter */}
          <div>
            <h3 className="text-3xl font-semibold tracking-tight">
              Sign up for our eNewsletter
            </h3>

            <form
              onSubmit={submitNewsletter}
              className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-4"
            >
              <input
                type="email"
                required
                placeholder="Email@email.com"
                className="h-11 rounded-md border-0 px-4 text-gray-900 placeholder:text-gray-500 focus:ring-2 focus:ring-emerald-400"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <input
                type="text"
                required
                placeholder="Enter your zip"
                className="h-11 rounded-md border-0 px-4 text-gray-900 placeholder:text-gray-500 focus:ring-2 focus:ring-emerald-400"
                value={zip}
                onChange={(e) => setZip(e.target.value)}
              />
              <button
                type="submit"
                className="h-11 rounded-md bg-[#6c2bd9] hover:bg-[#5b23b9] transition font-semibold"
              >
                Submit
              </button>
            </form>

            <div className="mt-8">
              <p className="text-sm/6 mb-3 opacity-90">Connect with Us</p>
              <div className="flex items-center gap-3">
                <Social
                  icon={<FaFacebookF />}
                  href="https://www.facebook.com/profile.php?id=61580686253934"
                  label="Facebook"
                />
                <Social
                  icon={<FaXTwitter />}
                  href="https://twitter.com"
                  label="X"
                />
                <Social
                  icon={<FaLinkedinIn />}
                  href="https://linkedin.com"
                  label="LinkedIn"
                />
                <Social
                  icon={<FaYoutube />}
                  href="https://youtube.com"
                  label="YouTube"
                />
                <Social
                  icon={<FaInstagram />}
                  href="https://instagram.com"
                  label="Instagram"
                />
                <Social
                  icon={<FaTiktok />}
                  href="https://tiktok.com"
                  label="TikTok"
                />
              </div>
            </div>
          </div>

          {/* Right: Brand / Phone / Finder / CTA */}
          <div className="grid gap-6 lg:pl-16">
            <div>
              <div className="text-3xl font-semibold leading-tight">
                {brand}
              </div>
              <div className="mt-4 h-[2px] w-24 bg-white/30" />
            </div>

            <div>
              <div className="text-sm font-semibold tracking-wide uppercase opacity-90">
                Call Our Office
              </div>
              <a
                href={phoneHref}
                className="mt-1 block text-3xl md:text-4xl font-bold hover:text-emerald-300 transition"
              >
                {phoneDisplay}
              </a>
            </div>

            <form
              onSubmit={submitFinder}
              className="grid grid-cols-[1fr_auto] gap-3"
            >
              <div>
                <label className="text-sm font-semibold block mb-1">
                  Find a Location
                </label>
                <div className="relative">
                  <input
                    type="text"
                    placeholder={officeFinderPlaceholder}
                    className="h-11 w-full rounded-md border-0 px-4 pr-10 text-gray-900 placeholder:text-gray-500 focus:ring-2 focus:ring-emerald-400"
                    value={loc}
                    onChange={(e) => setLoc(e.target.value)}
                  />
                  <span className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-[#6c2bd9] text-xl">
                    ›
                  </span>
                </div>
              </div>
              <button
                type="submit"
                className="self-end h-11 px-5 rounded-md bg-[#6c2bd9] hover:bg-[#5b23b9] transition font-semibold"
                aria-label="Search locations"
              >
                Search
              </button>
            </form>

            {/* {onOpenFranchise && (
              <div>
                <button
                  onClick={onOpenFranchise}
                  className="h-11 w-full sm:w-auto px-6 rounded-md bg-[#6c2bd9] hover:bg-[#5b23b9] transition font-semibold"
                >
                  Open a Franchise
                </button>
              </div>
            )} */}
          </div>
        </div>

        {/* Legal bar */}
        <div className="py-5 flex flex-col md:flex-row items-center justify-between gap-4 text-sm">
          <div className="flex flex-wrap items-center gap-x-5 gap-y-2 opacity-90">
            <a className="hover:text-emerald-300" href="/terms">
              Terms of Use
            </a>
            <a className="hover:text-emerald-300" href="/privacy-policy">
              Privacy Policy
            </a>
            {/* <a className="hover:text-emerald-300" href="/our-offices">
              Our Offices
            </a> */}
            {/* <a className="hover:text-emerald-300" href="/site-map">
              Site Map
            </a> */}
            <a className="hover:text-emerald-300" href="/do-not-sell">
              Do Not Sell My Personal Information
            </a>
            <button
              className="hover:text-emerald-300"
              onClick={() => {
                try {
                  localStorage.removeItem("privacyNoticeDismissed");
                  window.location.reload();
                } catch (err) {
                  console.warn("Unable to reset cookie settings:", err);
                }
              }}
            >
              Cookie Settings
            </button>
          </div>

          <div className="opacity-80">
            Copyright {new Date().getFullYear()} © AllWell Companion Home Care
            LLC.
          </div>
        </div>
      </div>

      {/* Floating trust badge (optional) */}
      <div className="fixed left-6 bottom-6">
        <div className="h-10 w-10 rounded-full bg-[#6c2bd9] shadow-lg flex items-center justify-center">
          <span className="text-white text-lg">✓</span>
        </div>
      </div>
    </footer>
  );
}

/** Small social icon button */
function Social({ icon, href, label }) {
  return (
    <a
      href={href}
      aria-label={label}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex h-9 w-9 items-center justify-center rounded-md bg-white/10 hover:bg-white/20 transition text-xl"
    >
      {icon}
    </a>
  );
}


